import { Directive, inject } from '@angular/core';
import type { SrmTicketModel } from '@libs/services/models';
import { LinkDirective } from '@libs/shared/ui';
import { SrmNavigationService } from '../srm-navigation.service';

@Directive({
  selector: 'a[uiSrmTicketLink]',
})
export class SrmTicketLinkDirective extends LinkDirective<SrmTicketModel> {
  private readonly navigation: SrmNavigationService = inject(SrmNavigationService);

  protected override getRawHref(link: SrmTicketModel): string {
    return this.navigation.ticketLink(link.srmIdentifier);
  }
}
